import { render, staticRenderFns } from "./SectionVideosChampCinema.vue?vue&type=template&id=c8d566e2&"
import script from "./SectionVideosChampCinema.vue?vue&type=script&lang=js&"
export * from "./SectionVideosChampCinema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports